// extracted by mini-css-extract-plugin
export default {"auth__title":"AuthContent_auth__title__5hxF3"};